import Section from "./Section";
import {H1, H2, H3} from "../Headlines";
import Paragraph from "../Paragraph";
import React from "react";

export default function Datenschutz() {
    return (
        <>
            <Section id={"datenschutz"} className={"!pt-0 text-left"}>
                <H1 id={"datenschutz-headline"}>Datenschutzerklärung nach der DSGVO</H1>
                <NameUndAnschriftDesVerantwortlichen/>
                <AllgmeinesZurDatenverarbeitung/>
                <BereitstellungDerWebseiteUndErstellungVonLogfiles/>
                <Cookies/>
            </Section>
        </>
    );
}

function NameUndAnschriftDesVerantwortlichen() {
    return <>
        <H2 id={'datenschutz-1'} className={'mt-8'}>1. Name und Anschrift des
            Verantwortlichen</H2>
        <Paragraph className={"mt-8"}>
            Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler
            Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:
            <ul className={'mt-4'}>
                <li>OMW Energieberatungsbüro GbR, Rhönblick 9, 63579 Freigericht, Deutschland</li>
                <li>Tel.: 0155-66255593</li>
                <li>E-Mail: info@omw-energieberatungsbuero.de</li>
                <li>Webseite: omw-energieberatung.de</li>
            </ul>
        </Paragraph>
    </>
}

function AllgmeinesZurDatenverarbeitung() {
    return <>
        <H2 id={'datenschutz-2'} className={'mt-8'}>2. Allgemeines zur Datenverarbeitung</H2>
        <H3 id={'datenschutz-2a'} className={'mt-8'}>a. Umfang der Verarbeitung
            personenbezogener Daten</H3>
        <Paragraph className={"mt-8"}>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung
            einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung
            personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme
            gilt in solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht
            möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
        </Paragraph>
        <H3 id={'datenschutz-2b'} className={'mt-8'}>b. Rechtsgrundlage für die Verarbeitung personenbezogener
            Daten</H3>
        <Paragraph className={"mt-8"}>
            Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person
            einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage.
            <br/>
            <br/>
            Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei
            die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt
            auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.
            <br/>
            <br/>
            Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich
            ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.
            <br/>
            <br/>
            Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person
            eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als
            Rechtsgrundlage.
            <br/>
            <br/>
            Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten
            erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte
            Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
        </Paragraph>
        <H3 id={'datenschutz-2c'} className={'mt-8'}>c. Datenlöschung und Speicherdauer</H3>
        <Paragraph className={"mt-8"}>
            Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der
            Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder
            nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
            Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn
            eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine
            Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung
            besteht.
        </Paragraph>
    </>
}

function BereitstellungDerWebseiteUndErstellungVonLogfiles() {
    return <>
        <H2 id={'datenschutz-3'} className={'mt-8'}>3. Bereitstellung der Website und Erstellung von Logfiles</H2>
        <H3 id={'datenschutz-3a'} className={'mt-8'}>a. Beschreibung und Umfang der Datenverarbeitung</H3>
        <Paragraph className={"mt-8"}>
            Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und Informationen vom
            Computersystem des aufrufenden Rechners.
            <br/>
            <br/>
            Folgende Daten werden hierbei erhoben:
            <ol className={'list-decimal ml-12'}>
                <li>Informationen über den Browsertyp und die verwendete Version</li>
                <li>Das Betriebssystem des Nutzers</li>
                <li>Den Internet-Service-Provider des Nutzers</li>
                <li>Die IP-Adresse des Nutzers</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Websites, von denen das System des Nutzers auf unsere Internetseite gelangt</li>
                <li>Websites, die vom System des Nutzers über unsere Website aufgerufen werden</li>
            </ol>
            <br/>
            Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser Daten
            zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.
        </Paragraph>
        <H3 id={'datenschutz-3b'} className={'mt-8'}>b. Rechtsgrundlage für die Datenverarbeitung</H3>
        <Paragraph className={"mt-8"}>
            Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f
            DSGVO.
        </Paragraph>
        <H3 id={'datenschutz-3c'} className={'mt-8'}>c. Zweck der Datenverarbeitung</H3>
        <Paragraph className={"mt-8"}>
            Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der
            Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des Nutzers für die Dauer der
            Sitzung gespeichert bleiben.
            <br/>
            <br/>
            Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website sicherzustellen. Zudem dienen uns
            die Daten zur technischen Optimierung der Website und zur Sicherstellung der Sicherheit unserer
            informationstechnischen Systeme. Eine Auswertung der Daten zu Marketingzwecken findet in diesem Zusammenhang
            nicht statt.
            <br/>
            <br/>
            In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach Art. 6 Abs. 1 lit. f
            DSGVO.
        </Paragraph>
        <H3 id={'datenschutz-3d'} className={'mt-8'}>d. Dauer der Speicherung</H3>
        <Paragraph className={"mt-8"}>
            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich
            sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige
            Sitzung beendet ist.
            <br/>
            <br/>
            Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens sieben Tagen der Fall. Eine
            darüberhinausgehende Speicherung ist möglich. In diesem Fall werden die IP-Adressen der Nutzer gelöscht oder
            verfremdet, sodass eine Zuordnung des aufrufenden Clients nicht mehr möglich ist.
        </Paragraph>
        <H3 id={'datenschutz-3e'} className={'mt-8'}>e. Widerspruchs- und Beseitigungsmöglichkeit</H3>
        <Paragraph className={"mt-8"}>
            Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den
            Betrieb der Internetseite zwingend erforderlich. Es besteht folglich seitens des Nutzers keine
            Widerspruchsmöglichkeit.
        </Paragraph>
    </>
}

function Cookies() {
    return <>
        <H2 id={'datenschutz-4'} className={'mt-8'}>4. Cookies</H2>
        <Paragraph className={"mt-8"}>
            Unsere Webseite verwendet keine Cookies.
        </Paragraph>
    </>
}
